export const ru = {
    campaign_broad_match_goal_all: 'Оптимизация конверсии по всем целям',
    campaign_broad_match_goal_changed:
        'Оптимизация конверсии {oldGoal} {newGoal}',
    campaign_broad_match_goal_id: 'Оптимизация конверсии по цели «{goalName}»',
    campaign_broad_match_limit:
        'Максимальный расход {limit}% от общего расхода кампании',
    campaign_broad_match_limit_changed:
        'Максимальный расход {oldLimit} {newLimit} от общего расхода кампании',
    'on-all-goals': 'по всем целям',
    'on-goal': 'по цели «{goalName}»'
};
